import { useGeoJSONLayer } from '@ljagis/react-mapping';
import { useEffect } from 'react';

import { cameraConfigs } from './cameraConfigs';
import { layers } from './layers';
import { fetchCameras, formatGeoJSON } from './utils';

export const useCameras = () => {
  const { setData } = useGeoJSONLayer({ layers });

  useEffect(() => {
    const fetch = async () => {
      const cameras = await fetchCameras(cameraConfigs);
      const geoJSON = formatGeoJSON(cameras);
      setData(geoJSON);
    };

    fetch();
  }, [setData]);

  return;
};
